import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { Picker } from 'antd-mobile';

import { appMethod as app } from '@utils/app';

import './DropDownCustomComponent.less';

export default function DropDownCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const titleObj = {
    height: transformPx2Rem(customFeature.titleStyle['line-height'], 320),
    color: customFeature.titleStyle.color,
    backgroundColor: customFeature.titleStyle['background-color'],
    fontSize: transformPx2Rem(customFeature.titleStyle['font-size'], 320),
    lineHeight: transformPx2Rem(customFeature.titleStyle['line-height'], 320),
    fontWeight: customFeature.titleStyle['font-weight'],
    fontStyle: customFeature.titleStyle['font-style'],
    textDecoration: customFeature.titleStyle['text-decoration']
  };
  const pickerTitleObj = {
    height: transformPx2Rem(customFeature.contentStyle['line-height'], 320),
    color: customFeature.contentStyle.color,
    backgroundColor: customFeature.contentStyle['background-color'],
    fontSize: transformPx2Rem(customFeature.contentStyle['font-size'], 320),
    lineHeight: transformPx2Rem(customFeature.contentStyle['line-height'], 320),
    fontWeight: customFeature.contentStyle['font-weight'],
    fontStyle: customFeature.contentStyle['font-style'],
    textDecoration: customFeature.contentStyle['text-decoration']
  };
  /**
   * 组件内容处理
   */   
  /**
   * 下拉选项中的contents.options处理为组件需要的optionsData格式
   */
  customFeature.contents.forEach((item) => {
    item['optionsData'] = item['options'].map((item, index) => ({
      label: item,
      value: item
    }));
  })
  /**
   * Picker内部组件
   */
  const PickerTitle = ({ extra, onClick, children }) => (
    <div className="picker-title" style={pickerTitleObj} onClick={onClick}>{children}{extra}</div>
  );
  /**
   * 绑定事件
   * v: 当前【下拉栏】选中的值
   * i: 当前【下拉栏】的索引
   */
  function changeDropDown(v, i) {
    let value = v;
    let index = i;
    let pageInstance = app.getAppCurrentPage();
    let compindex    = props.index;
    let formcompindex = formCompindex;
    let segment      = customFeature.segment;
    let componentKey = 'eles[' + formcompindex +'].content[' + compindex + ']';
    let datakey = `eles[${formCompindex}].form_data.${customFeature.segment}`;

    if (!segment) {
      app.showModal({
        content: '该组件【下拉选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    let newdata = {};
    newdata[componentKey + '.dropDown'] = data.dropDown || [];
    newdata[componentKey + '.dropDown'][index] = value;
    newdata[datakey] = newdata[componentKey + '.dropDown'].join(',');
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component drop-down" style={styleObj}>
      <div className="title" style={titleObj}>{customFeature.name}</div>
      {
        customFeature.contents.map((item, index) => (
          <Picker
            key={index}
            cols={1}
            extra={(data.dropDown && data.dropDown[index]) || item.name}
            data={item.optionsData}
            onChange={(value) => changeDropDown(value, index)}
            >
            <PickerTitle></PickerTitle>
          </Picker>
        ))
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/drop-down-custom-component/DropDownCustomComponent.jsx